// Small display helpers shared across the web app.

// Backend stores naive UTC (no trailing Z); append Z so the browser
// doesn't mis-read it as local time.
function coerce(v) {
  if (!v) return null;
  let s = v;
  if (typeof s === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(s)) {
    s = s + "Z";
  }
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

export function fmtDate(v) {
  const d = coerce(v);
  if (!d) return "—";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(v) {
  const d = coerce(v);
  if (!d) return "—";
  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function fmtMoney(n) {
  const v = Number(n || 0);
  return `£${v.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Status pill styling used for inspection/quote/invoice statuses.
export function statusTone(status) {
  const s = String(status || "").toLowerCase();
  if (["pass", "accepted", "paid", "shared", "completed", "verified"].includes(s))
    return "bg-emerald-100 text-emerald-800 border-emerald-200";
  if (["fail", "declined", "cancelled", "overdue"].includes(s))
    return "bg-red-100 text-red-800 border-red-200";
  if (["review", "sent", "pending", "draft", "open", "in_progress", "assigned", "awaiting_scheduling", "scheduled"].includes(s))
    return "bg-amber-100 text-amber-800 border-amber-200";
  if (["no_access"].includes(s)) return "bg-amber-100 text-amber-800 border-amber-200";
  if (["missed"].includes(s)) return "bg-orange-100 text-orange-800 border-orange-200";
  return "bg-slate-100 text-slate-700 border-slate-200";
}

const INSPECTION_STATUS_LABELS = {
  pass: "Satisfactory",
  pass_with_observations: "Satisfactory (advisory)",
  fail: "Remedial action required",
  review: "Further review required",
  no_access: "No access",
  not_inspected: "Not inspected",
};

export function prettyStatus(status) {
  const k = String(status || "").toLowerCase();
  if (INSPECTION_STATUS_LABELS[k]) return INSPECTION_STATUS_LABELS[k];
  return String(status || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function apiError(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return e?.message || fallback;
}
